export default __webpack_public_path__ + "static/media/bg-2.7f1bc2b0.jpg";